/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {TSSerializable} from './TSSerializable';
import TSAbstractBemerkungEntity from './TSAbstractBemerkungEntity';
import {TSSchadenfallStatus} from './enums/TSSchadenfallStatus';
import moment from 'moment';

export default class TSSystemBemerkung extends TSAbstractBemerkungEntity implements TSSerializable<TSSystemBemerkung> {

    private _preStatus: TSSchadenfallStatus;

    private _postStatus: TSSchadenfallStatus;

    public get preStatus(): TSSchadenfallStatus {
        return this._preStatus;
    }

    public set preStatus(value: TSSchadenfallStatus) {
        this._preStatus = value;
    }

    public get postStatus(): TSSchadenfallStatus {
        return this._postStatus;
    }

    public set postStatus(value: TSSchadenfallStatus) {
        this._postStatus = value;
    }

    deserialize(restObject: any): TSSystemBemerkung {
        super.deserialize(restObject);
        this.preStatus = restObject.preStatus;
        this.postStatus = restObject.postStatus;

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        // Don't send them down...
        restObject.preStatus = undefined;
        restObject.postStatus = undefined;

        return restObject;
    }

    public static getDeserializer = (systemBemerkung: any) => {
        return new TSSystemBemerkung().deserialize(systemBemerkung);
    };

    public static getSerializer = (systemBemerkung: any) => {
        return systemBemerkung.serialize(systemBemerkung);
    };

    public getBesitzerName(): string {
        return 'SYSTEM_MELDUNG';
    }

    getTimestampErstellt(): moment.Moment {
        if (this.timestampErstellt) {
            return this.timestampErstellt;
        }
        return moment();
    }

    getPreStatus(): TSSchadenfallStatus | undefined {
        return this.preStatus;
    }

    getPostStatus(): TSSchadenfallStatus | undefined {
        return this.postStatus;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSSystemBemerkung.ts